export const committer = (prevState, fields) => {
  const keys = Object.keys(fields);
  const state = prevState instanceof Array ? [...prevState] : { ...prevState };

  for (let i = 0, l = keys.length; i < l; i += 1) {
    let key = keys[i];
    let value = fields[key];

    if (fields instanceof Array) {
      [key] = Object.keys(fields[i]);
      value = fields[i][key];
    }

    const isObject = value instanceof Object;

    if (value === '-') {
      state.splice(key, 1);
    } else if (isObject && value['+']) {
      if (state[key] !== undefined) {
        state.splice(key, 0, value['+']);
      } else {
        state[key] = value['+'];
      }
    } else if (isObject && value['=']) {
      state[key] = committer(state[key], value['=']);
    } else {
      state[key] = value;
    }
  }

  if (state instanceof Array) {
    return state.filter((i) => i !== undefined);
  }

  return state;
};
